import { Routes } from '@angular/router';

import { HomeComponent } from '../components/home/home.component';
import { AprobadoComponent } from '../components/aprobado/aprobado.component';
import { RechazadoComponent } from '../components/rechazado/rechazado.component';
import { ErrorWebpayComponent } from '../components/error-webpay/error-webpay.component';
import { RedirectComponent } from '../components/redirect/redirect.component';
import { ErrorRetornoComponent } from '../components/error-retorno/error-retorno.component';

const appRoutes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'success', component: AprobadoComponent },
    { path: 'reject', component: RechazadoComponent },
    { path: 'errorWebpay', component: ErrorWebpayComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: 'errorRetorno', component: ErrorRetornoComponent },
];

export default appRoutes;
